export const API_ENDPOINTS = {

    // Use relative paths - Nginx will proxy /api/* to backend and /media/* ..to media files....ss.
    // BASE_URL: '/api/',
    // MEDIA_URL: '/media/',

    // development
    BASE_URL: 'https://devdashboard.nexgenagritech.ai/api/',
    
    //  
    // BASE_URL: 'https://dashboard.nexgenagritech.ai/api/',

    
    POST_send_otp: 'send_admin_otp/',
    POST_login: 'dashboard_login/', 
    POST_refresh_access_token: 'refresh-access-token/',
    GET_products: 'e-commerce/admin-order/list-user-orders/',
    GET_product_status_count: 'e-commerce/admin-order/get-user-order-status-counts/',
    UPDATE_product_status: 'e-commerce/admin-order/update-order-status/',
    UPDATE_payment_status: 'e-commerce/admin-order/update-payment-status/',
    UPDATE_new_payment_status: 'e-commerce/admin-order/new_update_payment_status/',
    POST_edit_order: 'e-commerce/order/edit/',
    GET_edit_order_summary: 'e-commerce/order/edit-summary/',
    POST_add_company : 'e-commerce/company/add-company/',
    GET_company: 'e-commerce/company/get-company/', 
    UPDATE_company: 'e-commerce/company/update-company/',
    DELETE_company: 'e-commerce/company/delete-company/',
    GET_payment_status_choices: 'e-commerce/order/get-payment_status_choices/',
    GET_advance_payment_methods: 'e-commerce/advance_payment_method/get-advance_payment_method/',
    GET_order_by_choices: 'e-commerce/order/get_order_by_choices/',

    POST_add_product_category : 'e-commerce/product_category/add-product_category/',
    GET_product_category: 'e-commerce/product_category/get-product_category_by_company_id/',
    UPDATE_product_category: 'e-commerce/product_category/update-product_category/',
    DELETE_product_category: 'e-commerce/product_category/delete-product_category/',

    GET_talk_to_agronomist : 'm2/talk_to_agronomist/get-talk_to_agronomist/',
    UPDATE_consultation_status : 'm2/talk_to_agronomist/update-talk-to-agronomist/',

    POST_bulk_upload_product : 'e-commerce/bulk-order/upload_bulk_purchase_excel/',
    GET_order_status_choices: 'e-commerce/order/get-order_status_choices/',
    GET_order_status_choices_with_count: 'e-commerce/order/get-order_status_choices_with_count/',
    GET_bulk_upload_product : 'e-commerce/bulk-order/get_bulk_purchase/',
    GET_bulk_upload_template : 'e-commerce/bulk-order/get_template/',
    GET_bulk_purchase_end_users: 'e-commerce/bulk-order/get_bulk_purchase_end_users/',
    POST_create_delivery_challan: 'e-commerce/order/create-delivery_challan/',
    GET_generate_zip_file: 'e-commerce/order/download_zip_of_invoice_or_challan/',
    POST_send_challan_on_email: 'e-commerce/order/send-challan-on-email/',
    
    GET_advance_export_users: 'e-commerce/bulk-order/get_bulk_purchase_end_users/',
    GET_advance_export_product_category: 'e-commerce/product_category/get-product_category/',
    GET_advance_export_product_category_by_company_id: 'e-commerce/product_category/get-product_category_by_company_id/',
    GET_advance_export_order_status: 'e-commerce/order/get-order_status/',
    GET_advance_export_company: 'e-commerce/company/get-company/',

    POST_advance_export: 'e-commerce/order/export-orders_excel/',

    GET_farmers: 'm2/user/get-all-farmers/',

    // Product Management APIs
    GET_product_categories: 'e-commerce/product_category/get-product_category/',
    GET_all_products: 'e-commerce/product/get-product_by_category_filter_dashboard/',
    POST_add_product: 'e-commerce/product/add-product/',
    POST_add_or_delete_product_images: 'e-commerce/product/add-or_delete_product_images/',
    PUT_update_product: 'e-commerce/product/update-product/',
    DELETE_product: 'e-commerce/product/delete-product/',
    
    // Brand and Vendor APIs (if needed)
    GET_brands: 'e-commerce/brand/get-brands/',
    GET_vendors: 'e-commerce/vendor/get-vendors/',

    GET_post: 'discussion_forum/get-post-by-category-id/',
    GET_comment: 'discussion_forum/get-comment-by-post-id/',
    DELETE_post: 'discussion_forum/delete-post/',
    DELETE_comment: 'discussion_forum/delete-comment/',
    GET_post_liked_user_by_post_id: 'discussion_forum/get-post_liked_user_by_post_id/',

    POST_add_event_type: 'm2/events/add-event-type/',
    GET_admin_event_type: 'm2/events/get-admin-event-types/',
    UPDATE_event_type_sequence: 'm2/events/resequence-event-type/',
    DELETE_event_type: 'm2/events/delete-event-type/',
    UPDATE_event_type:'m2/events/update-event-type/',
    
    POST_create_crop:'m2/fertilizer/add-crop/',
    GET_admin_crop_types :'m2/fertilizer/get-admin-crops/',
    UPDATE_admin_crop_types_sequence :'m2/fertilizer/resequence-crop/',
    DELETE_admin_crop_types :'m2/fertilizer/delete-crop/',
    UPDATE_admin_crop_types :'m2/fertilizer/update-crop/',

    // Analytics
    GET_farmer_engagement_activity_metrics: 'analytics/farmer-engagement/activity-metrics/',
    GET_farmer_engagement_farmers_analytics: 'analytics/farmer-engagement/farmers-analytics/',
    GET_sales_revenue_overview: 'analytics/sales/revenue-overview/',
    GET_sales_revenue_by_product: 'analytics/sales/top-products/',
    GET_sales_revenue_by_category: 'analytics/sales/category-performance/',
    // GET_farmer_engagement_farmers_analytics: 'analytics/farmer-engagement/farmers-analytics/',

    // Reports
    GET_reports_list: 'analytics/reports/list/',
    POST_reports_create: 'analytics/reports/create/',
    GET_reports_detail: 'analytics/reports/detail/',
    POST_reports_generate_pdf: 'analytics/reports/generate-pdf/',
    POST_reports_send_email: 'analytics/reports/send-email/',
    DELETE_daily_report: 'analytics/reports/delete/',

    // Courses (placeholders for future integration)
    GET_courses: 'course/get-courses/',
    POST_create_course: 'course/add-course/',
    PUT_update_course: 'course/update-course/',
    DELETE_course: 'course/delete-course/',

    // new api ....
    GET_course_type: 'course/get-course_type/',
    POST_create_course_type: 'course/add-course_type/',
    PUT_update_course_type: 'course/update-course_type/',
    DELETE_course_type: 'course/delete-course_type/',

    GET_crops: 'm2/fertilizer/get-crops/',
    GET_crops_guid: 'm2/crop-guide/get-crops-by-country/?user_id=10',

    GET_dispatch_persons: 'e-commerce/dispatch_person/get-dispatch_person/',
    GET_company_related_users: 'get_company_related_users/',
    DELETE_admin_Product: 'e-commerce/product/delete-product/',
    POST_add_product_size: 'e-commerce/product/add-product-size/',
    PUT_update_product_size: 'e-commerce/product/update-product-size/',
    DELETE_product_size: 'e-commerce/product/delete-product-size/',
    GET_product_size_by_id: 'e-commerce/product/get-product-size-by-id/',

    
    POST_add_product_stock: 'e-commerce/product_stock/add-product_stock/',
    GET_product_stock: 'e-commerce/product_stock/get-product_stock/',
    GET_product_stock_by_id: 'e-commerce/product_stock/get-product_stock_by_id/',
    PUT_update_product_stock: 'e-commerce/product_stock/update-product_stock/',
    DELETE_product_stock: 'e-commerce/product_stock/delete-product_stock/',
    GET_product_stock_by_product_id: 'e-commerce/product_stock/get-product_stock_by_product_id/',

    // ------------------------Groceries----------------------------
    GET_groceries: 'llm_translation/grocery-translations-list/',
    Add_grocery: 'llm_translation/grocery-translations-create/',
    Update_grocery: 'llm_translation/grocery-translations-update/',
    Delete_grocery: 'llm_translation/grocery-translations-delete/',

    // --------------------Permissions--------------------------------
    Get_user_types: 'm2/user_type_permissions/get_user_types/',
    Add_user_type: 'm2/user_type_permissions/add_user_type/',
    Update_user_type: 'm2/user_type_permissions/update_user_type/',
    Delete_user_type: 'm2/user_type_permissions/delete_user_type/',
    Update_permission: 'm2/user_type_permissions/update_permission/',
    Get_permissions: 'm2/user_type_permissions/get_permissions/',
    Add_permission: 'm2/user_type_permissions/add_permission/',
    Delete_permission: 'm2/user_type_permissions/delete_permission/',

    // -------------------------Invoice-----------------
    Get_Invoice: 'e-commerce/invoice_details_of_company/get-invoice_details_of_company/',
    Add_Invoice: 'e-commerce/invoice_details_of_company/add-invoice_details_of_company/',
    Update_Invoice: 'e-commerce/invoice_details_of_company/update-invoice_details_of_company/',
    Delete_Invoice: 'e-commerce/invoice_details_of_company/delete-invoice_details_of_company/',

    // -------------------------users-----------------
    Get_Users: 'm2/user/get-users-excluded/',
    Add_Users: 'm2/user/add-user/',
    Update_Users: 'm2/user/update-admin-user/',
    Delete_Users: 'm2/user/delete-user/',
    Get_User_types: 'm2/user_type_permissions/get_user_types_except/',


    //qoutation/performa
    GET_quotations: 'e-commerce/quotation/get-quotations/',
    GET_quotation_type_choices: 'e-commerce/quotation/get-quotation_type_choices/',
    GET_status_choices: 'e-commerce/quotation/get-status_choices/',
    GET_payment_mode_choices: 'e-commerce/quotation/get-payment_mode_choices/',
    GET_delivery_mode_choices: 'e-commerce/quotation/get-delivery_mode_choices/',
    GET_source_choices: 'e-commerce/quotation/get-source_choices/',
    GET_category_choices: 'e-commerce/quotation/get-category_choices/',
    GET_company_choices: 'e-commerce/company/get-company/',
    GET_measure_units: 'e-commerce/measure_units/get-measure_units/',
    POST_send_quotation: 'e-commerce/quotation/send_quotation_email/',
    POST_add_quotation: 'e-commerce/quotation/add-quotation/',
    GET_product_by_company_and_category_filter: 'e-commerce/product/get-product_by_company_and_category_filter/',

    GET_enquiry_form: 'm2/enquiry_form/get-enquiry_form/',
    GET_field_visit: 'm2/field_visit/get-field_visit/',
    GET_assigned_field_visit: 'm2/field_visit/get-assigned-field-visit/',
    POST_assign_field_visit: 'm2/field_visit/assign-field-visit/',
    PUT_update_assigned_field_visit_status: 'm2/field_visit/update-assigned-field-visit-status/',
    GET_export_excel_field_visit: 'm2/field_visit/export-excel-field_visit/',
    POST_field_visit_excel: 'm2/field_visit/import-field-visit-excel/',
    download_field_visit_template: 'm2/field_visit/download-field-visit-template',
    GET_export_excel_enquiry_form: 'm2/enquiry_form/export-enquiry-excel/',
    GET_enquiry_executives: 'm2/enquiry_form/get-enquiry-executives/',
    GET_farmer_enquiry_dashboard: 'dashboard/farmer-enquiry/',
    GET_quotation_dashboard: 'dashboard/quotation/',
    GET_field_visit_dashboard: 'dashboard/field-visit/',
    GET_talk_to_agronomist_dashboard: 'dashboard/talk-to-agronomist/',
    POST_enquiry_excel:'m2/enquiry_form/import-enquiry-excel/',
    download_form:'m2/enquiry_form/download-template/',
    Talk_to_agronomist_dashboard: 'm2/talk_to_agronomist/talk_to_agronomist_dashboard/',


    
    // AI Chat Bot APIs
    POST_add_gpt_sample_question: 'm2/gpt-sample-question/add-gpt-sample-question/',
    GET_gpt_sample_questions: 'm2/gpt-sample-question/get-gpt-sample-questions/',
    PUT_update_gpt_sample_question: 'm2/gpt-sample-question/update-gpt-sample-question/',
    DELETE_gpt_sample_question: 'm2/gpt-sample-question/delete-gpt-sample-question/',
    GET_supported_languages: 'llm_translation/supported-languages-list/',

    POST_create_company_login: 'create_company_login/',
    PUT_update_company_login: 'update_company_login/',

    GET_COUNTRIES: "get_country/",
    GET_STATES: "get_state/",
    GET_DISTRICTS: "m2/district/get-district_by_state/",
    GET_TALUKA: "m2/taluka/get-taluka_by_district/",

    GET_CROPS_BY_COUNTRY: "m2/crop-guide/get-crops-by-country",
    CREATE_CROP_GUIDE: "m2/crop-guide/create_crop_guide/",
    DELETE_CROP_DETAILS: "m2/crop-guide/delete_crop_details/",
    GET_CROP_DETAILS_BY_ID: "m2/crop-guide/get-crop-details-by-id/",
    UPDATE_CROP_GUIDE: "m2/crop-guide/update_crop_guide/",
    GET_COUNTRIES_FOR_CROP_GUIDE: "m2/crop-guide/get-countries/",

    // Disease Advisory APIs
    // Category APIs (using provided URLs - base URL will be prepended)
    POST_add_category: 'm2/categories/add-category/',
    GET_categories: 'm2/categories/get-categories/',
    GET_disease_categories: 'm2/categories/get-categories/', // Alias for AskQuestion compatibility
    PUT_update_category: 'm2/categories/update-category/',
    DELETE_category: 'm2/categories/delete-category/',
    
    // Subcategory APIs (using provided URLs)
    POST_add_subcategory: 'm2/categories/add-subcategory/',
    GET_all_subcategories: 'm2/categories/get-subcategories/',
    GET_subcategories_by_category: 'm2/categories/get-subcategories-by-category-id/',
    GET_disease_subcategories: 'm2/categories/get-subcategories-by-category-id/', // Alias for AskQuestion compatibility
    PUT_update_subcategory: 'm2/categories/update-sub-category/',
    DELETE_subcategory: 'm2/categories/delete-sub-category/',
    
    // Disease Advisory CRUD APIs
    POST_check_health: 'm2/check-health/', // Add Disease Advisory API
    GET_disease_advisory: 'm2/disease-advisory/get-disease-advisory/',
    PUT_update_disease_advisory: 'm2/disease-advisory/update-disease-advisory/',
    DELETE_disease_advisory: 'm2/disease-advisory/delete-disease-advisory/',
    GET_disease_advisory_question_by_category: 'm2/disease_advisory_question/get-disease_advisory_question-by-category/',
    GET_disease_advisory_faq: 'm2/disease-advisory/get-faq-by-subcategory/', // For AskQuestion compatibility
    
    // FAQ CRUD APIs
    POST_add_faq: 'm2/disease_advisory_question/add-disease_advisory_question/',
    PUT_update_faq: 'm2/disease_advisory_question/update-disease_advisory_question/',
    DELETE_faq_disease_advisory: 'm2/disease_advisory_question/delete-disease_advisory_question/',
    POST_Add_faq: 'm2/faq/add-faq/',
    GET_faq: 'm2/faq/get-faq/',
    GET_faq_by_id: 'm2/faq/get-faq-by-id/',
    GET_faq_by_category: 'm2/faq/get-faq-by-category/',
    UPDATE_feq_new : 'm2/faq/update-faq/',
    GET_categories_for_faq: 'm2/faq/get-faq-categories/',
    DELETE_faq:'m2/faq/delete-faq/',
    IMPORT_FAQ: 'm2/faq/import_faqs_from_excel/',
    download_faq_template:'m2/faq/download-faq-template/',

    // return and cancel request
    Get_cancel_request: 'e-commerce/order/get_cancel_requests/',
    Get_return_request: 'e-commerce/order/get_return_requests/',
    Update_cancel_request: 'e-commerce/order/update_cancel_request/',
    Update_return_request: 'e-commerce/order/update_return_request/',
    Refund_button_click: '/e-commerce/admin-order/check_payment_status/',

    // Support
    POST_create_support_request: 'support/create-support-request/',
    GET_support_requests: 'support/get-support-requests/',
    GET_support_request_by_id: 'support/get-support-request-by-id/',
    PUT_update_support_request: 'support/update-support-request/',
    PUT_update_support_status: 'support/update-support-status/',
    PUT_reopen_support_request: 'support/reopen-support-request/',
    DELETE_support_request: 'support/delete-support-request/',
    GET_support_status_choices: 'support/get-support-status-choices/',
    GET_support_status_count: 'support/support-status-count/',
    GET_support_status_logs: 'support/get-support-status-logs/',

    // Transaction
    GET_pending_payments: 'e-commerce/advance_payment_done/pending-payments/',
    UPDATE_transaction_status: 'e-commerce/advance_payment_done/update-transaction-status/',


  };

// API Endpoint to Page Route Mapping
// Used for redirecting to the appropriate page when clicking on API endpoints
export const API_ENDPOINT_ROUTES = {
    // Quotation/Proforma Invoice endpoints
    POST_add_quotation: '/dashboard/Quotation-proforma',
    GET_product_by_company_and_category_filter: '/dashboard/Quotation-proforma',
    GET_quotations: '/dashboard/Quotation-proforma',
    GET_quotation_type_choices: '/dashboard/Quotation-proforma',
    GET_status_choices: '/dashboard/Quotation-proforma',
    GET_payment_mode_choices: '/dashboard/Quotation-proforma',
    GET_delivery_mode_choices: '/dashboard/Quotation-proforma',
    GET_source_choices: '/dashboard/Quotation-proforma',
    GET_category_choices: '/dashboard/Quotation-proforma',
    GET_measure_units: '/dashboard/Quotation-proforma',
    POST_send_quotation: '/dashboard/Quotation-proforma',
    GET_product_category: '/dashboard/Quotation-proforma', // Used in QuotationProformaInvoice for fetching categories by company
};
  